import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function handleRemoveResource(
  task: Identifiable<Task>,
  { resource }: Boundaries["removeResourceFromPlanzone"]["request"],
): Identifiable<Task> {
  return calculateAdvancement({
    ...task,
    allocations: task.allocations.filter(
      (allocation) => allocation.resource.uuid === resource.uuid,
    ),
  });
}

export { handleRemoveResource };
